import transactionService from 'services/transaction';
import { startLoader, stopLoader } from './loader';

export const SET_TRANSACTIONS = '@transaction/set-transactions';
export const SET_FILTERS = '@transaction/set-filters';
export const CLEAN_FILTERS = '@transaction/clean-filters';
export const SET_ORDER = '@transaction/set-order';

export const getTransactions = (tray: any, filters: any, order: any, headerTray: 'retakes' | 'inspections' | 'auctions') => {
  const customOrder = {
    order: order.name,
    direction: order.direction
  };

  return async (dispatch: any) => {
    dispatch(startLoader());
    dispatch({
      type: SET_TRANSACTIONS,
      payload: []
    });
    const transactions = await transactionService.getTransactions(tray?.name || 'search', { ...filters, ...customOrder, type: headerTray });
    dispatch({
      type: SET_TRANSACTIONS,
      payload: transactions
    });
    dispatch(stopLoader());
  };
};
export const removeTransaction = (ids: any, transactions: any) => {
  return (dispatch: any) => {
    let result = transactions.filter((t: any) => !ids.includes(t.id));
    dispatch({
      type: SET_TRANSACTIONS,
      payload: result
    });
  };
};
export const setFilters = (filters: any) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_FILTERS,
      payload: filters
    });
  };
};
export const cleanFilters = () => {
  return (dispatch: any) => {
    dispatch({
      type: CLEAN_FILTERS
    });
  };
};

export const setOrder = (order: any) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_ORDER,
      payload: order
    });
  };
};
